export default __webpack_public_path__ + "static/media/midterm1.ccec30a5.jpg";